/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FieldArray, Formik } from "formik";

import { service } from "../../service/service";
import { convertStringInNumber, getRoles, getUsers, postProjects, putProjects, returnIdProjectManager } from "./libs";
import { IconAdd, IconTrash } from "../../../../icons";
import { CreateProjectUsers, IClients, ReqProjectsCreate, Roles, UserRole } from "../../model";
import { ModalMessage } from "../../../../components/ModalMessage";
import Spinner from "../../../../components/Spinner/index";
import IconButton from "../../../../components/IconButton";
import InputSelect from "../../../../components/Input-select";
import useAppData from "../../../../hook/useAppData";
import InputFormik from "../../../../components/InputFormik";
import ButtonGroup from "./sub-module/ButtonGroup";

import { toastError, toastSuccess, toastWarn } from "../../../../components/Toast";
import { Toaster } from "react-hot-toast";
import Input from "../../../../components/Input";
import { DataCollaborator } from "../../../Collaborator/model";
import CheckboxesTags from "../../../../components/CheckboxSelected";
import { UploadImage } from "../../../../components/CropperImage";
import { currentDate } from "../../../../libs/dateUtils";
import { AddNewFieldSelect, IInfo } from "../../../../components/AddNewFieldModal/AddNewFieldSelect";
import { ModalPopUp } from "../../../../components/ModalPopUp";
import "./form-projects.component.scss"; // FAVOR NAO APAGAR
import { ACCESS } from "../../../Profile/constants";
import { getRoleInProject, postRoleInProject } from "../../../RoleInProject/service";

const initialValues: CreateProjectUsers = {
  name: "",
  clientId: 0,
  projectManager: "",
  status: "Ativo",
  // clientName: ""
  collaborators: [],
};

interface ISubmitInProject extends CreateProjectUsers {
  is_deleted: boolean;
}

const STATUSLIST = [{ name: "Ativo" }, { name: "Cancelado" }, { name: "Concluído" }];

function FormProjects(props: any) {
  const params: any = props.match.params.id;
  const history = useHistory();
  const { token, profileId, corporationId, accessIds } = useAppData();
  const [modo, setModo] = useState<"create" | "update">("create");
  const [needSpinner, setNeedSpinner] = useState(true);
  const [miniSpinner, setMiniSpinner] = useState(true);
  const [needModalMessage, setNeedModalMessage] = useState({
    status: false,
    id: 0,
  });

  const [initialValue, setInitialValueUpdate] = useState<CreateProjectUsers>(initialValues);
  const [users, setUsers] = useState([] as any[]);
  const [roles, setRoles] = useState([] as Roles[]);
  const [clients, setClients] = useState<IClients[]>();
  const [imageProject, setImageProject] = useState();
  const [newRoleInProject, setNewRoleInProject] = useState<IInfo>();

  const PROJECT_MANAGER = returnIdProjectManager(roles);

  useEffect(() => {
    getLists();
    setMiniSpinner(false);
    if (!params) return setNeedSpinner(false);
    if (props?.match?.url?.includes("clients")) setClientScreen();
    else updateFields();
  }, []);

  useEffect(() => {
    if (initialValue?.clientId || (initialValue?.name?.length && users && clients && roles)) {
      setNeedSpinner(true);
      setTimeout(() => {
        setNeedSpinner(false);
      }, 500);
    }
  }, [initialValue, users, clients, roles]);

  useEffect(() => {
    setMiniSpinner(true);
    setTimeout(() => {
      setMiniSpinner(false);
    }, 500);
  }, [roles]);

  async function getLists() {
    const res: ReqProjectsCreate = await service.getCreateProjects(token);
    setUsers(res?.users);
    setClients(res?.clients);
    getRolesApi();
  }

  async function getRolesApi() {
    const res = await getRoleInProject({ token });
    if (!res?.length) return setMiniSpinner(false);
    getRoles(setRoles, res);
  }

  function setClientScreen() {
    const data: CreateProjectUsers = {
      ...initialValue,
      clientId: params,
    };
    setInitialValueUpdate(data);
  }

  async function handleFormSubmit(value: CreateProjectUsers) {
    if (verefierIfHasAllOk(value)) return;
    const result = await convertAlocationTimePorcent(value?.collaborators);
    const collaborators = convertStringInNumber(result);
    const formData: ISubmitInProject = {
      ...value,
      collaborators: collaborators,
      clientId: Number(value.clientId),
      isDeleted: value?.status === "Ativo" ? false : true,
      is_deleted: value?.status === "Ativo" ? false : true,
      status: value?.status ? value?.status : "Ativo",
      endDate: value?.status === "Ativo" ? "" : currentDate().replaceAll("/", "-"),
    };
    const objOfRequest = { formData, file: imageProject };
    if (verefyRoles(formData)) return;
    if (modo === "create") {
      const data = await postProjects(objOfRequest, token);
      if (!data?.ok) return toastError("Erro ao salvar a Criação do projeto!");
      return history.push("/projects");
    }
    if (modo === "update") {
      setMiniSpinner(true);
      const data = await putProjects(objOfRequest, params, token);
      if (!data?.ok) return toastError("Erro ao salvar a Atualização do projeto!");
      return history.push("/projects");
    }
  }

  function verefyRoles(formData) {
    let count = 0;
    let countNegative = 0;
    formData.collaborators?.forEach((colaborators) => {
      if (!colaborators.rolesId?.length) countNegative--;
      // if (colaborators.rolesId?.includes(PROJECT_MANAGER) && corporationId === 1) count++;
    });

    // if (count === 0 && corporationId === 1) return toastError("Precisa adicionar um gerente de projeto");
    // if (count > 1 && corporationId === 1) return toastError("Só pode ter apenas um gerente de projeto");
    if (countNegative < 0) return toastError(`Algum profissional não tem função definida, é obrigatória uma função por profissional`);
  }

  function verefierIfHasAllOk(value: CreateProjectUsers) {
    if (!value?.clientId) {
      toastError("Cliente é obrigatório");
      return true;
    }
    if (!value?.name?.trim()) {
      toastError("Nome do Projeto é obrigatório");
      return true;
    }
    return false;
  }

  async function getBaseUserHours(id: number) {
    const usersList = users?.length ? users : await getUsers(token);
    const data = usersList?.filter((item: any) => {
      if (item?.id === +id) {
        return true;
      }
    });
    return data[0]?.hourBase;
  }

  async function calcAlocationTime(userRoles: UserRole[]) {
    if (userRoles) {
      for (let item of userRoles) {
        const base_hour = await getBaseUserHours(Number(item?.userId));
        item.allocationTime = Number(item?.allocationTime) * base_hour;
      }
    }
    return userRoles;
  }

  async function convertAlocationTimePorcent(userRoles: UserRole[]) {
    const newUserRoles = [];
    for (let item of userRoles) {
      const hour_baseDefault = 168;
      const base_hour: number = (await getBaseUserHours(Number(item?.userId))) || hour_baseDefault;
      const obj = {
        ...item,
        allocationTime: item?.allocationTime / base_hour,
      };
      newUserRoles.push(obj);
    }
    return newUserRoles;
  }

  async function updateFields() {
    const data = await service.getByIdProjects(String(params), token);
    if (data.statusCode === 404) {
      setNeedSpinner(false);
      return toastWarn("Sistema instável no momento, talvez alguns dados nao estejam carregando de forma correta");
    }
    setModo("update");
    data.project.collaborators = await calcAlocationTime(data?.project?.collaborators);
    setInitialValueUpdate(data?.project);
  }

  function handleConfirmClick() {
    props.history.push("/projects");
  }

  async function handleDeleteImage() {
    const responseOfDeleteClick = await service.delImageProjects(token, params);
    if (responseOfDeleteClick?.status) return toastSuccess("Imagem removida com sucesso!");
    return toastError("Não foi possível remover a imagem, tente novamente mais tarde!");
  }

  return (
    <Spinner status={needSpinner}>
      <Toaster />
      <ModalPopUp title={newRoleInProject?.label} status={!!newRoleInProject?.value} onClickCancel={() => setNewRoleInProject(undefined)}>
        <AddNewFieldSelect info={newRoleInProject} />
      </ModalPopUp>
      <ModalMessage
        status={needModalMessage.status}
        id={needModalMessage.id}
        onClickCancel={setNeedModalMessage}
        onClickConfirm={handleConfirmClick}
        text="Você tem certeza disso?"
      />
      <div className="projectsContainer container">
        <div className="title-form form-box-title">
          {modo === "create" ? <h1>Adicionar um novo Projeto</h1> : <h1>Atualizar dados do Projeto</h1>}
        </div>
        <Formik
          initialValues={initialValue}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
        >
          {(props) => (
            <form className="form-container box-form" onSubmit={props.handleSubmit}>
              <div className="row box-row flex flex-nowrap">
                <InputFormik
                  className="form-input"
                  onChange={(e: any) => {
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values?.name}
                  name="name"
                  label="Nome do Projeto"
                  type="text"
                  placeholder="Digite o nome do Projeto..."
                  required={true}
                  autofocus={true}
                  disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                />
                <UploadImage img={initialValue?.img} setImage={setImageProject} className="image-project" handleDeleteImage={handleDeleteImage} />
              </div>
              <div className="row box-row">
                <InputSelect
                  name="clientId"
                  label="Cliente"
                  placeholder="Escolha o cliente"
                  onChange={props.handleChange}
                  value={props?.values?.clientId ? props?.values?.clientId : 0}
                  list={clients}
                  required={true}
                  disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                />
                <InputFormik
                  className="form-input"
                  onChange={(e: any) => {
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={props?.values?.projectManager}
                  name="projectManager"
                  label="Responsável pelo Projeto no cliente"
                  type="text"
                  placeholder="Digite o responsável pelo projeto..."
                  disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                />
                <InputSelect
                  label="Status do Projeto"
                  name="status"
                  placeholder="Escolha o status do projeto"
                  onChange={props.handleChange}
                  list={STATUSLIST}
                  value={props?.values?.status}
                  disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                />
              </div>

              {props?.values?.collaborators?.length > 0 && <h1>Profissionais do Projeto</h1>}

              <FieldArray name="collaborators">
                {({ insert, remove, push }) => (
                  <div className="box-row rowContainer">
                    <Spinner className="spinner" status={miniSpinner}>
                      {props?.values?.collaborators?.length > 0 &&
                        props?.values?.collaborators?.map((collaborator: any, index: number) => {
                          function changeValue(value: any) {
                            const data = value?.filter((item: any) => item?.checked)?.map((item: any) => item?.fieldId);

                            collaborator.rolesId = data;
                          }

                          function rolesDto() {
                            return roles?.map((role) => {
                              if (!collaborator.rolesId.includes(role.fieldId)) return role;
                              return {
                                ...role,
                                checked: !role.checked,
                              };
                            });
                          }

                          return (
                            <>
                              <div className="row box-row" key={index}>
                                <InputSelect
                                  className="field-arr-select"
                                  onChange={(e: any) => {
                                    props.handleChange(e);
                                  }}
                                  onBlur={props.handleBlur}
                                  value={props?.values?.collaborators[index].userId}
                                  label="Selecione o profissional"
                                  name={`collaborators.${index}.userId`}
                                  list={users}
                                  disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                                />

                                <div className="box-row">
                                  <CheckboxesTags
                                    label="Selecione função"
                                    listOptions={rolesDto()}
                                    setState={changeValue}
                                    placeholder="Função"
                                    limit={2}
                                    disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                                    add={{ name: "roleInProject", label: "+ Função no Projeto", value: -1 }}
                                    setAdd={(e) =>
                                      setNewRoleInProject({
                                        name: e?.name,
                                        label: "Nova Função no Projeto",
                                        value: e?.id,
                                        save: (body, token) => postRoleInProject({ token, body }),
                                        objSave: (value) => {
                                          return { name: value };
                                        },
                                        action: () => {
                                          getRolesApi();
                                          setMiniSpinner(true);
                                        },
                                        exit: () => setNewRoleInProject(undefined),
                                      })
                                    }
                                  />

                                  <div className="box-row">
                                    <Input
                                      className="allocation"
                                      label="Alocação (hrs)"
                                      name={`collaborators[${index}].allocationTime`}
                                      type="number"
                                      placeholder="Tempo de Alocação"
                                      setValue={(e: any) => {
                                        props.handleChange(e);
                                      }}
                                      value={props?.values?.collaborators[index].allocationTime}
                                      required={true}
                                      disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                                    />
                                    <Input
                                      className="allocation"
                                      label="Rate/Hora"
                                      name={`collaborators[${index}].rate_hour`}
                                      type="text"
                                      placeholder="Rate/hora"
                                      setValue={(e: any) => {
                                        props.handleChange(e);
                                      }}
                                      value={props?.values?.collaborators[index].rate_hour}
                                      required={true}
                                      disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                                    />
                                    <Input
                                      className="box-row"
                                      label="Desvincular"
                                      name={`collaborators[${index}].end_date`}
                                      type="date"
                                      placeholder="DD/MM/AAAA"
                                      setValue={(e: any) => {
                                        props.handleChange(e);
                                      }}
                                      value={props?.values?.collaborators[index].end_date}
                                      disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      {accessIds?.includes(ACCESS.PROJECT_write) && (
                        <IconButton icon={IconAdd} className="add" onClick={() => push({ userId: 1, rolesId: [], allocationTime: 168 })} />
                      )}
                    </Spinner>
                  </div>
                )}
              </FieldArray>
              <div className="w-full h-full flex flex-col justify-between mt-8">
                <div className="h-full flex-col justify-between m-2 w-full">
                  <p className="text-xl font-familyPoppins mt-8 mb-2"><b>Desvincular:</b> Selecione uma data passada ou a data atual para desvincular o colaborador imediantamente do projeto.
                    No caso de uma data futura, o coloborador continuará a poder apontar horas no projeto até a data estipulada.
                    Os dados de apontamento não serão removidos ou alterados</p>
                </div>
              </div>
              {modo === "update" ? (
                <div className="form-button">
                  <ButtonGroup
                    onClick={() => history.push("/projects")}
                    textCancel="Cancelar"
                    textConfirm="Salvar"
                    disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                  />
                </div>
              ) : (
                <div className="form-button">
                  <ButtonGroup
                    onClick={() => setNeedModalMessage({ status: true, id: 0 })}
                    textCancel="Cancelar"
                    textConfirm=" Salvar"
                    disabled={!accessIds?.includes(ACCESS.PROJECT_write)}
                  />
                </div>
              )}
            </form>
          )}
        </Formik>
      </div>
    </Spinner>
  );
}
export default FormProjects;

// value={calcAllocationTimeOfInput(props?.values?.collaborators[index])}

// function calcAllocationTimeOfInput(currentCollaborator) {     return users.find((user) => user.id === currentCollaborator?.userId).hourBase * currentCollaborator?.allocationTime;   }
